// reset time to 00:00:00 UTC for server to handle properly
export const withoutTime = (dateTime: Date | null): Date | null => {
    if (dateTime === null) return null;
    const date = new Date(dateTime);
    date.setUTCHours(0, 0, 0, 0);
    return date;
};
